<section class="cta-bg px-16">
<div class="awalan-logo">
  <a routerLink="/"  class="flex items-center pt-6">
      <img
        src="/images/website-logo-v2.png"
        alt="Awalan"
        class="w-42 h-16 object-contain"
      />
    </a>
</div>

<div class="cta-content">
<h2>الإستثمار دائما معاك</h2>
<p class="py-4">تحول الرؤية الزراعية إلى واقع مستدام للإستثمار الزراعى ,شركة متخصصة<br> فى تطوير وتنفيذ المشاريع الزراعية وفق أحدث الأساليب والتقنيات.</p>
</div>

<div class="flex items-center gap-4 cursor-pointer">


    <a class="w-12 h-12 flex items-center justify-center border-2 border-(--color-main) rounded-full text-(--color-main) bg-(--color-secondary)  hover:bg-(--color-main)  hover:text-(--color-secondary) hover:border-(--color-secondary)   transition duration-300">
    <i class="fa-brands fa-youtube"></i>
    </a>


      <a class="w-12 h-12 flex items-center justify-center border-2 border-(--color-main) rounded-full text-(--color-main) bg-(--color-secondary)  hover:bg-(--color-main) hover:text-(--color-secondary) hover:border-(--color-secondary) transition duration-300">
      <i class="fa-brands fa-linkedin-in"></i>
      </a>


        <a class="w-12 h-12 flex items-center justify-center border-2 border-(--color-main) rounded-full text-(--color-main) bg-(--color-secondary) hover:bg-(--color-main) hover:text-(--color-secondary) hover:border-(--color-secondary)  transition duration-300">
        <i class="fa-brands fa-tiktok"></i>
        </a>



        <a class="w-12 h-12 flex items-center justify-center border-2 border-(--color-main) rounded-full text-(--color-main) bg-(--color-secondary)  hover:bg-(--color-main) hover:text-(--color-secondary) hover:border-(--color-secondary)  transition duration-300">
        <i class="fa-brands fa-instagram"></i>
        </a>


          <a class="w-12 h-12 flex items-center justify-center border-2 border-(--color-main) rounded-full text-(--color-main) bg-(--color-secondary)  hover:bg-(--color-main)  hover:text-(--color-secondary) hover:border-(--color-secondary)  transition duration-300">
          <i class="fa-brands fa-facebook-f"></i>
          </a>








</div>
</section>
